module.exports = __webpack_public_path__ + "static/media/en.e55c0df9.svg";